import { generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';

const notificationsFeatureKey = ['notification'] as const;

export const getNotificationsListQueryKey = generateListQueryKey({
  prefix: notificationsFeatureKey,
});

export const getNotificationsInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getNotificationsListQueryKey,
});
